import { useState } from "react";
import { uploadArticleImage } from "@/lib/graphql/upload";
import { toast } from "sonner";

interface UseImageUploadOptions {
  category?: string;
  onSuccess?: (url: string) => void;
}

export function useImageUpload({
  category = "post-thumbnail",
  onSuccess,
}: UseImageUploadOptions = {}) {
  const [isUploading, setIsUploading] = useState(false);

  const upload = async (file: File): Promise<string | null> => {
    setIsUploading(true);

    try {
      const result = await uploadArticleImage(file, category);

      if (!result.success || !result.url) {
        throw new Error(result.message || "업로드에 실패했습니다");
      }

      onSuccess?.(result.url);
      return result.url;
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "업로드에 실패했습니다";
      toast.error("이미지 업로드 실패", { description: message });
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return { upload, isUploading };
}
